import Step from "@fae/source/models/Step.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"
import * as PlotFlourishes from "@fae/source/data/plot/flourishes.js"

export default function HandleStatusEffects() {
    return (stage) => {
        const steps = []
        Object.values(stage.units).forEach((unit) => {
            if(unit.effects == undefined) return
            if(unit.effects["poisoned"] != undefined) {
                steps.push(PlotSteps.ShudderUnit({
                    "unitKey": unit.key,
                    "intensity": 0.05,
                }))
                steps.push(Step.deltastage({
                    "unit": {
                        "key": unit.key,
                        "health": Math.max(0, unit.health - (unit.effects["poisoned"].power || 0))
                    }
                }))
            }
            if(unit.effects["regenerate"] != undefined) {
                steps.push(PlotSteps.ShudderUnit({
                    "unitKey": unit.key,
                    "intensity": 0.05,
                }))
                steps.push(Step.deltastage({
                    "unit": {
                        "key": unit.key,
                        "health": Math.min(unit.maxhealth, unit.health + (unit.effects["regenerate"].power || 0))
                    }
                }))
            }
        })
        return steps
    }
}
